"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var axios_1 = require("axios");
var TinyCache = require("tinycache");
var utils_1 = require("../utils");
var BaseAPI = /** @class */ (function () {
    function BaseAPI(baseUrl, withToken, cacheKey, expire, skipScopeApiUrl) {
        if (baseUrl === void 0) { baseUrl = ""; }
        if (expire === void 0) { expire = 5 * 60 * 1000; }
        if (skipScopeApiUrl === void 0) { skipScopeApiUrl = false; }
        this.cacheKey = cacheKey;
        this.expire = expire;
        this.baseUrl = baseUrl;
        this.withToken = withToken;
        this.cache = new TinyCache();
        this._basePath = "";
        this.scopeApiUrl = "";
        this.skipScopeApiUrl = skipScopeApiUrl;
        this.http = axios_1.default.create({
            baseURL: this.baseUrl
        });
    }
    Object.defineProperty(BaseAPI.prototype, "basePath", {
        get: function () {
            return this._basePath;
        },
        set: function (value) {
            if (value && value.startsWith("/")) {
                value = value.slice(1);
            }
            this._basePath = value;
        },
        enumerable: true,
        configurable: true
    });
    BaseAPI.prototype.setCache = function (value) {
        if (!this.cacheKey) {
            throw new Error("no cache key");
        }
        return this.cache.put(this.cacheKey, value, this.expire);
    };
    BaseAPI.prototype.setCacheByAccounot = function (value, account) {
        if (!this.cacheKey) {
            throw new Error("no cache key");
        }
        var cache = this.getCache();
        if (!cache) {
            cache = {};
        }
        cache[account] = value;
        return this.cache.put(this.cacheKey, cache, this.expire);
    };
    BaseAPI.prototype.getCacheByAccount = function (account) {
        if (!this.cacheKey) {
            throw new Error("no cache key");
        }
        var cache = this.cache.get(this.cacheKey);
        return cache && cache[account] ? cache[account] : null;
    };
    BaseAPI.prototype.getCache = function () {
        if (!this.cacheKey) {
            throw new Error("no cache key");
        }
        return this.cache.get(this.cacheKey);
    };
    BaseAPI.prototype.get = function (url, config, withToken) {
        if (config === void 0) { config = {}; }
        return this.request(tslib_1.__assign({ method: "get", url: url }, config), withToken);
    };
    BaseAPI.prototype.post = function (url, config, withToken) {
        if (config === void 0) { config = {}; }
        return this.request(tslib_1.__assign({ method: "post", url: url }, config), withToken);
    };
    BaseAPI.prototype.patch = function (url, config, withToken) {
        if (config === void 0) { config = {}; }
        return this.request(tslib_1.__assign({ method: "patch", url: url }, config), withToken);
    };
    BaseAPI.prototype.put = function (url, config, withToken) {
        if (config === void 0) { config = {}; }
        return this.request(tslib_1.__assign({ method: "put", url: url }, config), withToken);
    };
    BaseAPI.prototype.delete = function (url, config, withToken) {
        if (config === void 0) { config = {}; }
        return this.request(tslib_1.__assign({ method: "delete", url: url }, config), withToken);
    };
    BaseAPI.prototype.request = function (config, withToken) {
        if ((this.withToken || withToken) && this.accessToken) {
            config.headers = tslib_1.__assign({}, config.headers, { Authorization: "Bearer " + this.accessToken });
        }
        // We add this for testing new api's, we can add apiUrl on the scope in the user and the requests go there..
        if (window.__sdk__ && window.__sdk__.auth.session && !this.skipScopeApiUrl && !this.scopeApiUrl && !config.baseURL && (process.env.NODE_ENV === "production" || process.env.PROD_API)) {
            var scope = window.__sdk__.auth.session.user.scopes.find(function (scopeRow) { return scopeRow.scope === window.__sdk__.auth._scope; });
            (scope && scope.apiUrl) && (this.scopeApiUrl = scope.apiUrl);
        }
        if (!this.skipScopeApiUrl && this.scopeApiUrl) {
            config.baseURL = this.scopeApiUrl;
        }
        return this.http.request(config);
    };
    BaseAPI.prototype.pathify = function (tail) {
        tail = utils_1.digest(tail)
            .digest(function (ctx) { return ctx instanceof Array ? ctx.join("/") : ctx; })
            .digest(function (ctx) { return ctx.startsWith("/") ? ctx.slice(1) : ctx; })
            .done();
        return (this.basePath ? "/" + this.basePath : "") + "/" + tail;
    };
    return BaseAPI;
}());
exports.default = BaseAPI;
